import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import { useAuth } from '../contexts/AuthContext';

/**
 * Componente para probar el sistema de notificaciones
 * Permite enviar notificaciones de prueba a usuarios específicos o a todos los administradores
 */
const NotificationTest = () => {
  const { createNotification, notifyAdmins } = useNotifications();
  const { currentUser } = useAuth();

  // Función para crear una notificación de prueba para el usuario actual
  const createTestNotification = async () => {
    if (!currentUser) {
      alert('Debes iniciar sesión para probar las notificaciones');
      return;
    }
    
    try {
      console.log('🔔 Creando notificación de prueba para:', currentUser.uid);
      
      await createNotification({
        userId: currentUser.uid,
        title: 'Notificación de Prueba',
        message: 'Esta es una notificación de prueba para verificar que el sistema funciona correctamente.',
        icon: '🔔',
        category: 'system',
        priority: 'medium',
        relatedId: 'test-' + Date.now(),
        relatedType: 'test',
        actionUrl: '/notifications'
      });
      
      console.log('✅ Notificación de prueba creada correctamente');
      alert('Notificación de prueba creada correctamente. Verifica la campanita de notificaciones.');
    } catch (error) {
      console.error('❌ Error creando notificación de prueba:', error);
      alert('Error al crear la notificación de prueba: ' + error.message);
    }
  };

  // Función para notificar a todos los administradores
  const notifyAllAdmins = async () => {
    if (!currentUser) {
      alert('Debes iniciar sesión para probar las notificaciones');
      return;
    }
    
    try {
      console.log('📢 Notificando a todos los administradores...');
      
      const result = await notifyAdmins({
        title: 'Notificación para Administradores',
        message: `Esta es una notificación de prueba enviada por ${currentUser.displayName || currentUser.email}`,
        icon: '👑',
        category: 'system',
        priority: 'high',
        relatedId: 'admin-test-' + Date.now(),
        relatedType: 'test',
        actionUrl: '/admin/notifications'
      });
      
      console.log('📊 Resultado de notificación a administradores:', result);
      alert(`Notificación enviada a ${result.success} administradores. ${result.failed} fallidas.`);
    } catch (error) {
      console.error('❌ Error notificando a administradores:', error);
      alert('Error al notificar a administradores: ' + error.message);
    }
  };

  return (
    <div style={{
      padding: '20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      maxWidth: '500px',
      margin: '20px auto'
    }}>
      <h2 style={{ marginTop: 0, color: '#333' }}>Prueba de Notificaciones</h2>
      
      <p style={{ color: '#666' }}>
        Usa estos botones para probar el sistema de notificaciones. Verifica que aparezcan en la campanita de notificaciones.
      </p>
      
      <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
        <button
          onClick={createTestNotification}
          style={{
            padding: '10px 15px',
            backgroundColor: '#4caf50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          Crear Notificación de Prueba
        </button>
        
        <button
          onClick={notifyAllAdmins}
          style={{
            padding: '10px 15px',
            backgroundColor: '#2196f3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          Notificar a Todos los Admins
        </button>
      </div>
      
      <div style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        <p><strong>Nota:</strong> Si no ves las notificaciones, verifica la consola del navegador para ver si hay errores.</p>
      </div>
    </div>
  );
};

export default NotificationTest;
